import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaArrowRight,
  FaHome,
  FaUtensils,
  FaSearch,
  FaShoppingBag,
} from "react-icons/fa";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#fffaf7]">
      {/* =========================
          Main Section
      ========================= */}
      <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-5 py-12">
        {/* =========================
            Background Decorations
        ========================= */}
        <div className="pointer-events-none absolute -left-32 -top-32 h-80 w-80 rounded-full bg-red-200/30 blur-3xl" />

        <div className="pointer-events-none absolute -bottom-40 -right-32 h-96 w-96 rounded-full bg-orange-200/30 blur-3xl" />

        <div className="pointer-events-none absolute left-[10%] top-[20%] h-3 w-3 rounded-full bg-red-400/40" />

        <div className="pointer-events-none absolute right-[15%] top-[25%] h-2 w-2 rounded-full bg-orange-400/50" />

        <div className="pointer-events-none absolute bottom-[22%] left-[18%] h-2 w-2 rounded-full bg-red-400/30" />

        {/* Decorative Circle */}
        <div className="pointer-events-none absolute right-[10%] bottom-[18%] hidden h-20 w-20 rounded-full border border-red-200/60 sm:block" />

        {/* =========================
            Content
        ========================= */}
        <div className="relative z-10 w-full max-w-2xl text-center">
          {/* Brand Icon */}
          <div className="mb-7">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-red-500 via-red-500 to-orange-500 shadow-xl shadow-red-200">
              <FaUtensils className="text-2xl text-white" />
            </div>
          </div>

          {/* 404 */}
          <div className="relative">
            <h1 className="select-none text-[120px] font-black leading-none tracking-[-0.08em] text-gray-900 sm:text-[170px]">
              <span className="text-red-500">4</span>
              <span className="text-orange-500">0</span>
              <span className="text-red-500">4</span>
            </h1>

            {/* Small floating icon */}
            <div className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 rotate-6 items-center justify-center rounded-2xl bg-white shadow-xl ring-1 ring-gray-100">
              <FaSearch className="text-lg text-gray-400" />
            </div>
          </div>

          {/* Heading */}
          <div className="mt-2">
            <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">
              Oops! Page Not Found
            </h2>

            <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-gray-500 sm:text-base">
              দুঃখিত, আপনি যে পেজটি খুঁজছেন সেটি পাওয়া যায়নি। হয়তো পেজটি সরানো
              হয়েছে অথবা URL টি ভুল হয়েছে।
            </p>
          </div>

          {/* =========================
              Quick Message Card
          ========================= */}
          <div className="mx-auto mt-7 flex max-w-md items-center gap-4 rounded-2xl border border-gray-100 bg-white px-5 py-4 text-left shadow-[0_10px_35px_rgba(0,0,0,0.06)]">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-red-50">
              <FaShoppingBag className="text-red-500" size={17} />
            </div>

            <div>
              <p className="text-sm font-bold text-gray-800">
                Let's get you back on track
              </p>

              <p className="mt-0.5 text-xs text-gray-400">
                Explore delicious food and great offers.
              </p>
            </div>
          </div>

          {/* =========================
              Buttons
          ========================= */}
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            {/* Home */}
            <Link
              to="/"
              className="group flex h-13 min-w-[190px] items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-red-500 via-red-500 to-orange-500 px-7 py-3.5 text-sm font-bold text-white shadow-lg shadow-red-200 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-red-200"
            >
              <FaHome size={15} />

              <span>Back to Home</span>

              <FaArrowRight
                size={12}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </Link>

            {/* Go Back */}
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="group flex h-13 min-w-[150px] items-center justify-center gap-2 rounded-2xl border border-gray-200 bg-white px-7 py-3.5 text-sm font-bold text-gray-700 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50"
            >
              <FaArrowLeft
                size={12}
                className="transition-transform duration-300 group-hover:-translate-x-1"
              />

              <span>Go Back</span>
            </button>
          </div>

          {/* =========================
              Brand Footer
          ========================= */}
          <div className="mt-10">
            <div className="flex items-center justify-center gap-2">
              <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-red-500 to-orange-500">
                <FaUtensils className="text-[11px] text-white" />
              </div>

              <p className="text-sm font-extrabold tracking-tight text-gray-800">
                Food<span className="text-red-500">Bite</span>
                <span className="text-orange-500">24</span>
              </p>
            </div>

            <p className="mt-2 text-[11px] text-gray-400">
              Your favorite food, just a bite away.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
